import { api } from "@/redux/api";

interface OnboardingTriggerResponse {
	message: string;
}

export const onboardingTriggerApi = api.injectEndpoints({
	endpoints: (builder) => ({
		triggerDeepResearchOnboarding: builder.mutation<OnboardingTriggerResponse, number>({
			query: (companyId) => ({
				url: `deep-research/onboarding`,
				method: "POST",
				params: { companyId },
			}),
		}),
		triggerSignalConfigOnboarding: builder.mutation<OnboardingTriggerResponse, number>({
			query: (companyId) => ({
				url: `signal/config/onboard`,
				method: "POST",
				params: { companyId },
			}),
		}),
		triggerKnowledgeDbOnboarding: builder.mutation<OnboardingTriggerResponse, number>({
			query: (companyId) => ({
				url: `knowledge-db/onboarding`,
				method: "POST",
				params: { companyId },
			}),
		}),
		triggerScoreOnboarding: builder.mutation<void, number>({
			query: (companyId) => ({
				url: `score/retrigger-onboarding`,
				method: "POST",
				body: { companyId },
			}),
		}),
	}),
});

export const {
	useTriggerDeepResearchOnboardingMutation,
	useTriggerSignalConfigOnboardingMutation,
	useTriggerKnowledgeDbOnboardingMutation,
	useTriggerScoreOnboardingMutation,
} = onboardingTriggerApi;
